var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"survey-container monitorSite"},[_c('NavBarAdmin'),_c('v-container',{staticClass:"page-body p-4 pt-3 bg-light-blue admin-pageX",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"data-app":"","wrap":""}},[_c('router-view')],1)],1),_c('FooterAdmin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }